/**
 * Cliente da página de Acessos aos Ambientes.
 *
 * <p>Nada aqui é público: a listagem devolve senha de teste em claro, e é a sessão
 * (o `api` já manda o token) que faz disso um cofre do time em vez de um vazamento.
 */
import { api } from '../../api/cliente';

const BASE = '/api/projetos/mistik-island/ambientes';

export interface Acesso {
  id: number;
  rotulo?: string;
  usuario: string;
  senha?: string;
  nota?: string;
}

export interface Ambiente {
  id: number;
  nome: string;
  url: string;
  nota?: string;
  acessos: Acesso[];
}

export interface Pagina {
  ambientes: Ambiente[];
}

export const CHAVE_ACESSOS = ['acessos'] as const;

export function listar(): Promise<Pagina> {
  return api<Pagina>(BASE);
}

export function criarAmbiente(corpo: {
  nome: string;
  url: string;
  nota?: string;
}): Promise<Ambiente> {
  return api<Ambiente>(BASE, { method: 'POST', body: JSON.stringify(corpo) });
}

export function salvarAmbiente(
  id: number,
  mudancas: Record<string, unknown>
): Promise<Ambiente> {
  return api<Ambiente>(`${BASE}/${id}`, { method: 'PATCH', body: JSON.stringify(mudancas) });
}

export function excluirAmbiente(id: number): Promise<void> {
  return api<void>(`${BASE}/${id}`, { method: 'DELETE' });
}

export function criarAcesso(
  ambienteId: number,
  corpo: { rotulo?: string; usuario: string; senha?: string; nota?: string }
): Promise<Acesso> {
  return api<Acesso>(`${BASE}/${ambienteId}/acessos`, {
    method: 'POST',
    body: JSON.stringify(corpo),
  });
}

export function salvarAcesso(id: number, mudancas: Record<string, unknown>): Promise<Acesso> {
  return api<Acesso>(`${BASE}/acessos/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(mudancas),
  });
}

export function excluirAcesso(id: number): Promise<void> {
  return api<void>(`${BASE}/acessos/${id}`, { method: 'DELETE' });
}
